export const phoneRule = v => {
    if(!v) {
        return true;
    }
    const regex = /^0[0-9]+$/;
    return v.length === 10 && regex.test(v) || 'Phone: 10 digits starting with 0';
}

export const hasLengthRule = v => {
    return !!v && v.trim().length > 0;
}

export const numberRule = v => {
    if(!v) {
        return true;
    }
    const regex = /[0-9]+$/;
    return regex.test(v) || 'Please enter a number! At least 0.';
}
